<template>
    <div style="background-color: #FFFFFF;padding: 10px;border-radius: 5px">
        <div style="width: 100%;height: 500px">
            <div style="margin: 5px;width: 700px;height: 500px" id="chartBody"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProcessOptionChart",
        props: ["data","links","selected"],
        data() {
            return {
                ChartOption: {
                    // 图的标题
                    title: {
                        text: '工艺段物料关系图'
                    },
                    // 提示框的配置
                    tooltip: {
                        formatter: function (x) {
                            return x.data.des;
                        }
                    },
                    // 工具箱
                    toolbox: {
                        // 显示工具箱
                        show: true,
                        feature: {
                            mark: {
                                show: true
                            },
                            // 还原
                            restore: {
                                show: true
                            },
                            // 保存为图片
                            saveAsImage: {
                                show: true
                            }
                        }
                    },
                    legend: [{
                        selectedMode:false,
                        data: [{name: "前工艺段"},{name: "当前工艺段"}, {name: "后工艺段"}, {name: "物料"}].map(function (a) {
                            return a.name;
                        }),
                        selected:{
                            "前工艺段":false,
                            "当前工艺段":false,
                            "后工艺段":false,
                            "物料":false
                        }
                    }],
                    series: [{
                        type: 'graph', // 类型:关系图
                        layout: 'force', //图的布局，类型为力导图
                        symbolSize: 40, // 调整节点的大小
                        roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移,可以设置成 'scale' 或者 'move'。设置成 true 为都开启
                        edgeSymbol: ['circle', 'arrow'],
                        edgeSymbolSize: [2, 10],
                        edgeLabel: {
                            normal: {
                                textStyle: {
                                    fontSize: 10
                                },
                                show: true,
                                formatter: function (x) {
                                    return x.data.name;
                                }
                            }
                        },
                        force: {
                            repulsion: 2500,
                            edgeLength: [10, 50]
                        },
                        draggable: true,
                        lineStyle: {
                            normal: {
                                width: 2,
                                color: '#4b565b',
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                textStyle: {}
                            }
                        },

                        // 数据
                        data: [],
                        links: [],
                        categories: [{name: "前工艺段"}, {name: "当前工艺段"},{name: "后工艺段"},  {name: "物料"}],
                    }]
                }
            }
        },
        methods: {
            drawPicture(){

            }
        },
        mounted() {

        },
        watch:{
            data:function(){
                this.ChartOption.series[0].data = this.data;
                this.ChartOption.series[0].links = this.links;
                this.ChartOption.legend[0].selected = this.selected;
                var myChart = this.$echarts.init(document.getElementById('chartBody'));
                myChart.setOption(this.ChartOption);
            },
            links:function () {
                this.ChartOption.series[0].data = this.data;
                this.ChartOption.series[0].links = this.links;
                this.ChartOption.legend[0].selected = this.selected;
                var myChart = this.$echarts.init(document.getElementById('chartBody'));
                myChart.setOption(this.ChartOption);
            },
            selected:function(){
                this.ChartOption.series[0].data = this.data;
                this.ChartOption.series[0].links = this.links;
                this.ChartOption.legend[0].selected = this.selected;
                var myChart = this.$echarts.init(document.getElementById('chartBody'));
                myChart.setOption(this.ChartOption);
            }
        }
    }
</script>

<style scoped>

</style>
